export const cardStyle = {
  textAlign: 'center',
  background: '#fff3cd',
  height: '40px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 5,
  borderRadius: '5px',
  marginBottom: 10,
};
export const barcodeCard = {
  background: '#fff',
  width: '100%',
  height: '120px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  padding: '20px',
  borderRadius: '10px',
};

export const qrScanButtonStyle = {
  width: '100%',
  height: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  fontSize: '16px',
  backgroundColor: 'rgb(247, 209, 0)',
  borderColor: 'rgb(63, 54, 6)',
  color: '#000',
};